import "./style.scss";

import { Button_Style, Button_Type } from "../Button/Button";
import { FC, useEffect, useState } from "react";

import Button from "../Button";
import { ReactComponent as IconClose } from "assets/img/icons/icon_Close.svg";
import { ReactComponent as IconShieldSmall } from "assets/img/icons/icon_shield_small.svg";

type ModalProps = {
    children?: React.ReactNode;
    type?: "info" | "success" | "error" | "warning";
    title?: string;
    subtitle?: string;
    isOpen: boolean;
    onClose: (event: React.MouseEvent) => void;
    onConfirm?: (event: React.MouseEvent) => void;
    labelOnConfirm?: string;
    confirmButtonDisabled?: boolean;
    infoModal?: boolean;
    hasTimer?: boolean;
    timer?: number;
    logo?: any;
    bgBody?: string;

};
const Modal: FC<ModalProps> = ({
    isOpen,
    onClose,
    title,
   subtitle,
    type,
    children,
    onConfirm,
    labelOnConfirm,
    confirmButtonDisabled,
    infoModal = false,
    logo,
    hasTimer = false,
    timer = 0,
   bgBody ,

    
}) => {
    const [modalOpen, setModalOpen] = useState(isOpen);
    
    const handleClose = (event: React.MouseEvent) => {
        setModalOpen(false);
        onClose(event);
    };


    const handleConfirm = async (event: React.MouseEvent) => {
        if (onConfirm) {
            try {
                await onConfirm(event);
            } catch (error) {
                // Handle the error from onConfirm here
                // console.error("Error during confirmation:", error);
            }
        } else {
            // setModalOpen(false);
            // onClose();
        }
    };

    

    return (
        <div className="w-100">
            <div
                className="modal--backdrop"
                onClick={handleClose}
            />
            <div className={`modal modal--${type ? type : "info"} shadow bg-light`}>
                <div className="modal__header px-6 py-4 d-flex justify-content-between align-items-center">
                    <div className={"d-flex flex-row justify-content-start align-items-center gap-1"}>
                        {logo && (
                          <span className={"bg-primary-70 p-2 rounded"}>{logo}</span>
                        )}
                        <span
                          className="modal__header__title d-flex flex-column justify-content-start align-items-start">
                            <span className={"bold"}>{title}</span>
                            <span className={"text-xs text-muted-foreground"}>{subtitle}</span>
                        </span>
                    </div>
                    <button onClick={handleClose}>
                        <IconClose
                          fill="#384050"
                            width={12}
                            height={12}
                        />
                    </button>
                </div>

                {/*BODY*/}
                <div className={`modal__body w-100 py-4 px-6 ${bgBody ?? 'bg-neutral-70'} d-flex flex-column gap-05 justify-content-center`}>{children}</div>

                {/*Footer*/}
                <div className="px-6 py-4 d-flex flex-wrap justify-content-between align-items-center py-1 gap-1">
                    <div className={"d-flex flex-row gap-05 justify-content-center align-items-center"}>
                        <span  className={"bg-primary-70 p-1 rounded"}>
                            <IconShieldSmall
                              fill="#fff"
                              width={12}
                              height={12}
                            />
                        </span>
                        <span className={"text-muted-foreground text-xs"}>
                            <span className={"text-primary bold"}>ID Tracker</span> vous protège 24/7
                        </span>
                    </div>
                    <div className={"d-flex gap-05 flex-row flex-wrap-reverse"}>
                        {!infoModal && (
                          <Button
                            overrideClassName={"bg-light hover:shadow-lg px-3 py-2 text-xs rounded border border-neutral-50 text-error-40 bold"}
                            label={labelOnConfirm ? labelOnConfirm : "ok"}
                            onClick={(e) => {
                                handleConfirm(e);
                            }}
                            disabled={confirmButtonDisabled}
                            type={type === "error" ? Button_Type.Error : type === "success" ? Button_Type.SUCCESS : Button_Type.PRIMARY}
                          />
                        )}
                        <Button
                          overrideClassName={"bg-light hover:shadow-lg px-3 py-2 text-xs rounded border border-neutral-50 text-primary bold"}
                          label="Fermer"
                          style={Button_Style.OUTLINED}
                          onClick={handleClose}
                          type={type === "error" ? Button_Type.Error : type === "success" ? Button_Type.SUCCESS : Button_Type.PRIMARY}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Modal;
